import { jsx as _jsx } from "react/jsx-runtime";
import { components } from 'react-select';
import DIcon from '../../DIcon';
import { useDContext } from '../../../contexts';
export default function DSelectDropdownIndicator(props) {
    const { iconMap: { chevronDown, }, } = useDContext();
    return (_jsx(components.DropdownIndicator, Object.assign({}, props, { children: _jsx(DIcon, { icon: chevronDown }) })));
}
//# sourceMappingURL=DSelectDropdownIndicator.js.map